import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/GlobalProvider";
import { FaEye, FaEyeSlash, FaLock, FaUserAlt, FaSpinner } from "react-icons/fa";
import CSDLogo_2 from "../../assets/CSDLogo_2.svg";

const Signin = () => {
  const navigate = useNavigate();
  const { signIn, user } = useAuth();

  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  const handleIdentifierSubmit = () => {
    if (!identifier.trim()) {
      setError("Please enter email or phone number.");
      return;
    }
    setError("");
    setStep(2);
  };

  const onSignInPress = async () => {
    setError("");
    setLoading(true);
    const result = await signIn(identifier, password);
    setLoading(false);
    if (result.success) {
      navigate("/dashboard");
    } else {
      setError(result.message);
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-secoundry">
      <div className="w-full max-w-md p-8 bg-primary rounded-2xl shadow-2xl mx-4">
        <div className="flex justify-center mb-4">
          <div className="bg-white p-4 rounded-full shadow-md">
            <img
              src={CSDLogo_2}
              alt="CRM Geni Logo"
              className="w-14 h-14 object-contain"
            />
          </div>
        </div>

        <h1 className="text-[24px] font-extrabold text-center text-white">
          CRM Geni
        </h1>
        <h2 className="text-[12px] font-semibold text-center text-white mb-6">
          Login to your dashboard
        </h2>

        <div className="space-y-4">
          {step === 1 && (
            <>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <FaUserAlt />
                </span>
                <input
                  type="text"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  placeholder="Email or Phone Number"
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-yellow-500 outline-none text-sm"
                />
              </div>

              {error && <p className="text-sm text-red-600 text-center">{error}</p>}

              <button
                onClick={handleIdentifierSubmit}
                className="w-full bg-primary-STYLE1 text-white font-bold py-2 rounded-full transition"
              >
                Next
              </button>
            </>
          )}

          {step === 2 && (
            <>
              <div className="text-white text-sm text-center">
                Logging in as <strong>{identifier}</strong>
              </div>

              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <FaLock />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-yellow-500 outline-none text-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              {error && <p className="text-sm text-red-600 text-center">{error}</p>}

              <div className="text-xs text-center text-gray-100 mt-2">
                ✓ Please read our{" "}
                <span
                  className="text-yellow-600 font-medium cursor-pointer hover:underline"
                  onClick={() => navigate("/termsconditions")}
                >
                  Terms & Conditions
                </span>
              </div>

              <button
                onClick={onSignInPress}
                disabled={loading}
                className={`w-full bg-primary-STYLE1 text-white font-bold py-2 rounded-full transition ${
                  loading ? "opacity-60 cursor-not-allowed" : ""
                }`}
              >
                {loading ? (
                  <span className="flex justify-center items-center gap-2">
                    <FaSpinner className="animate-spin" /> Logging in...
                  </span>
                ) : (
                  "Log in"
                )}
              </button>

              <button
                onClick={() => {
                  setStep(1);
                  setPassword("");
                  setError("");
                }}
                className="w-full text-xs text-yellow-200 mt-2 underline"
              >
                Change identifier
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Signin;
